import { render, staticRenderFns } from "./EnvironmentUpdate.vue?vue&type=template&id=6c97cda8&scoped=true&"
import script from "./EnvironmentUpdate.vue?vue&type=script&lang=js&"
export * from "./EnvironmentUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c97cda8",
  null
  
)

export default component.exports